// Canonical URL for the current route. `/new` and `/old` both canonicalize
// to `/` — they are chrome variants of the same page, not distinct content.
const cleanPath = (router) => {
  let p = router.asPath.split('?')[0].split('#')[0] || '/'
  if (p.length > 1) p = p.replace(/\/$/, '') // strip trailing slash except root
  return p === '/new' || p === '/old' ? '/' : p
}

export const canonicalUrl = (router) => `https://www.shippop.com${cleanPath(router)}`

export const alternateUrls = (router) => {
  const p = cleanPath(router)
  return {
    th: `https://www.shippop.com${p}`,
    en: `https://www.shippop.com/en${p === '/' ? '' : p}`,
  }
}
